export class ChunkLoadingError extends Error {
  private static readonly patterns = [/Loading chunk [\d]+ failed/i, /ChunkLoadError/i, /Failed to fetch dynamically imported module/i];

  constructor(message = 'Chunk loading failed') {
    super(message);
    this.name = 'ChunkLoadingError';
  }

  public static isChunkLoadingError(error: unknown): boolean {
    const errorDetails = [
      (error as { name?: string })?.name,
      (error as { message?: string })?.message,
      (error as { rejection?: { name?: string; message?: string } })?.rejection?.name,
      (error as { rejection?: { name?: string; message?: string } })?.rejection?.message,
      (error as { ngOriginalError?: { name?: string; message?: string } })?.ngOriginalError?.name,
      (error as { ngOriginalError?: { name?: string; message?: string } })?.ngOriginalError?.message
    ]
      .filter(Boolean)
      .join(' ');

    return ChunkLoadingError.patterns.some(pattern => pattern.test(errorDetails));
  }
}
